import { render, staticRenderFns } from "./ImgNumSay.vue?vue&type=template&id=a8ac995e&scoped=true"
import script from "./ImgNumSay.vue?vue&type=script&lang=js"
export * from "./ImgNumSay.vue?vue&type=script&lang=js"
import style0 from "./ImgNumSay.vue?vue&type=style&index=0&id=a8ac995e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ac995e",
  null
  
)

export default component.exports